/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.53"
        height="76.08"
        viewBox="0 0 95.53 76.08"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="m34.58.23-34 21a1.25 1.25 0 0 0-.32 1.84l.1.11a1.3 1.3 0 0 0 .29.22l59.26 31.85a1.24 1.24 0 0 0 1.22 0l33.8-20.71a1.25 1.25 0 0 0 0-2.14L35.93.2a1.23 1.23 0 0 0-1.35.03Zm.76 2.48 56.45 30.78L60.44 52.7 3.75 22.23Z"
          className="icon-fill icon-base"/><path
          fill="#0e497b"
          d="M.69 41.88a1.25 1.25 0 0 1 1 0l.13.07 58.57 31.47L93.5 53.11a1.28 1.28 0 0 1 1.05-.17h.12a1.25 1.25 0 0 1 .3 2.15l-.11.07-33.8 20.71a1.24 1.24 0 0 1-1.09.11l-.16-.08L.66 44.1a1.27 1.27 0 0 1-.45-.41l-.08-.13a1.25 1.25 0 0 1 .56-1.68Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M74.94 21.63a1.25 1.25 0 0 1-.27 1.65l-.12.08-32.74 20.76v20a1.27 1.27 0 0 1-1.13 1.25h-.12a1.26 1.26 0 0 1-1.25-1.12V43.44a1.26 1.26 0 0 1 .46-1l.12-.08L73.2 21.23a1.26 1.26 0 0 1 1.74.4ZM55.55 11.08a1.25 1.25 0 0 1-.31 1.64l-.11.08-33.79 20.34v19.92a1.26 1.26 0 0 1-1.12 1.25h-.13a1.25 1.25 0 0 1-1.24-1.12V32.43a1.25 1.25 0 0 1 .49-1l.12-.08 34.39-20.7a1.24 1.24 0 0 1 1.7.43Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="m56.36 20.24-1.86 1.14-.3-.14-.31-.14a8.18 8.18 0 0 0-5.51-.34 9 9 0 0 0-2.81 1.31c-1.53 1.07-2.09 2.31-1.68 3.66a10.92 10.92 0 0 0 .77 1.72c.35.71.73 1.41 1.08 2.12s0 1.16-.82 1.58a3 3 0 0 1-2.71.19 5.9 5.9 0 0 1-.89-.51 1.87 1.87 0 0 1-.9-1.77c.11-.8.66-1.18 1.2-1.77l-3.33-1.38a5.5 5.5 0 0 0-1.92 2.92 3.34 3.34 0 0 0 1.26 3.05l-2.37 1.47 1.67 1.25 2.35-1.46c.42.2.81.41 1.23.59a9 9 0 0 0 8.57-1c1.42-1.08 2-2.28 1.6-3.58a15 15 0 0 0-1.25-2.63 14.11 14.11 0 0 1-.72-1.59.65.65 0 0 1 0-.53c.49-1.05 2.34-1.51 3.59-1 .86.35 1.29.88 1.24 1.59A2.76 2.76 0 0 1 53 26.3c-.1.13-.19.27-.3.41l3.55 1a4.59 4.59 0 0 0 1.2-1.92 3.08 3.08 0 0 0-1.18-3.15l1.84-1.14Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M94.6 42.57h.14a1.25 1.25 0 0 1 .3 2.15l-.11.08-33.8 20.7a1.24 1.24 0 0 1-1.22 0L39.97 54.88a1.24 1.24 0 0 1-.47-1.69 1.26 1.26 0 0 1 1.57-.57l.12.06 19.25 10.33L93.5 42.76a1.29 1.29 0 0 1 .9-.2Zm-92.79-11 18.87 10.11a1.25 1.25 0 0 1-1.06 2.26l-.12-.06L.66 33.75a1.37 1.37 0 0 1-.2-.13l-.09-.08a1.25 1.25 0 0 1 1.44-2Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'PaperMoneyStackIcon';

export default Icon;
